module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_gamesoft_896465836dae63d0ddeea90a365fb1c6.png";